import { forwardRef } from 'react';
import Loader from './Loader';

const VARIANTS = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  ghost: 'btn-ghost',
  danger:
    'inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-red-600 to-rose-600 px-4 py-2.5 text-sm font-semibold text-white shadow-md shadow-red-500/25 hover:from-red-500 hover:to-rose-500 focus:outline-none focus:ring-2 focus:ring-rose-400/45 focus:ring-offset-2 focus:ring-offset-slate-50 dark:focus:ring-offset-slate-950 active:scale-[0.98] motion-reduce:active:scale-100 transition-all duration-150 disabled:opacity-50 disabled:active:scale-100',
};

const SIZES = {
  sm: 'text-xs px-3 py-1.5',
  md: '',
  lg: 'text-base px-5 py-3',
};

const Button = forwardRef(function Button(
  {
    variant = 'primary',
    size = 'md',
    loading = false,
    disabled = false,
    leftIcon = null,
    rightIcon = null,
    type = 'button',
    className = '',
    children,
    ...rest
  },
  ref
) {
  const base = VARIANTS[variant] || VARIANTS.primary;
  const sz = SIZES[size] || '';
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled || loading}
      className={`${base} ${sz} ${className}`.trim()}
      {...rest}
    >
      {loading ? <Loader size="xs" className="text-current" /> : leftIcon}
      <span>{children}</span>
      {!loading && rightIcon}
    </button>
  );
});

export default Button;
